import './dialog.scss'
;(function(window) {
  window.yxlDialog = yxlDialog

  function yxlDialog(opts) {
    this.opts = this.extend(this.defaults, opts)
    this.init()
  }

  yxlDialog.prototype.defaults = {
    target: null,
    width: 6,
    height: 'auto',
    title: '',
    content: '',
    value: '',
    scrollTop: '',
    ok: function() {}
  }

  yxlDialog.prototype.extend = function(dest, src) {
    for (var prop in src) {
      if (src.hasOwnProperty(prop)) {
        dest[prop] = src[prop]
      }
    }

    return dest
  }

  yxlDialog.prototype.template = function() {
    var title =
      "<div class='yxlDialog-header'>" +
      this.opts.title +
      "<div id='yxlDialog-close'>×</div></div>"
    var content =
      "<div class='yxlDialog-content'>" + this.opts.content + '</div>'
    var footer =
      "<div class='yxlDialog-footer'><button id='yxlDialog-ok'>确定</button><button id='yxlDialog-cancel'>取消</button></div>"

    var _yxlDialog = document.createElement('div')
    _yxlDialog.setAttribute('id', 'yxlDialog')
    _yxlDialog.innerHTML =
      "<div class='yxlDialog-mask'></div><div class='yxlDialog-inner'>" +
      title +
      content +
      footer +
      '</div>'

    return _yxlDialog
  }

  yxlDialog.prototype.bindEvents = function() {
    var _self = this
    var _yxlDialog = document.getElementById('yxlDialog')
    var _dom = document.getElementsByClassName('yxlDialog-content')[0]

    document
      .getElementById('yxlDialog-close')
      .addEventListener('click', function(e) {
        e.preventDefault()
        if (_dom.querySelectorAll('textarea').length > 0) {
          _dom.querySelector('textarea').value = ''
        }
        _self.modalHelper(0)
        _yxlDialog.style.display = 'none'
      })
    document
      .getElementById('yxlDialog-ok')
      .addEventListener('click', function(e) {
        e.preventDefault()
        console.log('哈哈')
        _self.opts.ok()
        _self.modalHelper(0)

        if (_dom.querySelectorAll('textarea').length > 0) {
          _dom.querySelector('textarea').value = ''
        }
        _yxlDialog.style.display = 'none'
      })
    document
      .getElementById('yxlDialog-cancel')
      .addEventListener('click', function(e) {
        e.preventDefault()
        //
        if (_dom.querySelectorAll('textarea').length > 0) {
          _dom.querySelector('textarea').value = ''
        }
        _self.modalHelper(0)
        _yxlDialog.style.display = 'none'
      })
  }

  yxlDialog.prototype.init = function() {
    var layout = this.template()
    if (!document.getElementById('yxlDialog')) {
      if (this.opts.target) {
        document.body.appendChild(layout)
        document
          .querySelector(this.opts.target)
          .addEventListener('click', function() {
            document.getElementById('yxlDialog').style.display = 'block'
          })
      } else {
        document.body.appendChild(layout)
        document.getElementById('yxlDialog').style.display = 'block'
      }
      this.modalHelper(1)
      this.bindEvents()
    } else {
      document.getElementById('yxlDialog').style.display = 'block'
      this.modalHelper(1)
    }
  }

  yxlDialog.prototype.modalHelper = function(type) {
    if (type === 1) {
      this.opts.scrollTop = document.scrollingElement.scrollTop
      console.log('嘿嘿')
      document.body.classList.add('modal-open')
      document.body.style.top = -this.opts.scrollTop + 'px'
    } else if (type === 0) {
      document.body.classList.remove('modal-open')
      document.scrollingElement.scrollTop = this.opts.scrollTop
    }
  }

  yxlDialog.prototype.size = function(w, h) {
    let _dom = document.getElementsByClassName('yxlDialog-inner')[0]
    _dom.style.width = 'auto'
    _dom.style.height = 'auto'
    if (typeof w === 'number') {
      _dom.style.width = w + 'rem'
    }

    if (typeof h === 'number') {
      _dom.style.height = h + 'rem'
    }
    return this
  }

  // yxl.prototype.getDom = function () {
  //   let wrap = document.createElement('div');
  //     wrap.innerHTML = this.opts.content;
  //     let body = document.body,
  //     name,
  //     i = 0,
  //     DOM = {wrap: $(wrap)},
  //     els = wrap.getElementsByTagName('*');
  //
  //   len = els.length;
  //   for ( ; i < len; i++) {
  //     name = els[i].className.split('yxlDialog-')[1];
  //     if(name) Dom[name] = document.getElementsByTagName(els[i])
  //   }
  //
  //   body.appendChild(wrap)
  //
  //   return DOM
  // }

  // yxlDialog.prototype.close = function () {
  //
  // }

  // yxlDialog.prototype.time = function (second, cb) {
  //   var _timer;
  //
  //   _timer && clearTimeout(_timer);
  //   cb && cb.call(this);
  //
  //   if(second){
  //     this._timer = setTimeout(() => {
  //       //关闭dialog
  //     },1000*second);
  //   }
  //   return this
  // }

  // function checkValue () {
  //   let _dom = document.getElementsByClassName('yxlDialog-content')[0],
  //     value;
  //   if (_dom.querySelectorAll('textarea','input').length > 0){
  //     switch (_dom.querySelectorAll('textarea','input')[0].className) {
  //       case 'textarea':
  //         value = _dom.querySelector('textarea').value
  //         break;
  //       case 'input' :
  //         value = _dom.querySelector('input').value
  //         break
  //     }
  //   }
  //   return value
  // }
})(window)



// WEBPACK FOOTER //
// ./src/public-resource/components/dialog/index.js